
import React from 'react';
import { Link } from 'react-router-dom';
import { Home, AlertTriangle, Terminal, Search } from 'lucide-react';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center bg-paper text-black px-6 relative overflow-hidden pt-20">
      
      {/* Background Grid Pattern */}
      <div className="absolute inset-0 pointer-events-none opacity-5" style={{backgroundImage: 'radial-gradient(#000 1px, transparent 1px)', backgroundSize: '30px 30px'}}></div>

      <div className="max-w-3xl text-center relative z-10 animate-fade-in">
        
        {/* System Error Label */}
        <div className="text-[10px] font-bold uppercase tracking-[0.5em] text-red-600 mb-6 flex items-center justify-center gap-2 animate-pulse">
          <AlertTriangle size={14} />
          System Error: Void Sector
        </div>

        {/* Huge 404 Typography */}
        <div className="relative">
             <h1 className="text-[8rem] md:text-[14rem] leading-none font-serif font-black text-black opacity-10 select-none absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 blur-sm">
            404
            </h1>
            <h1 className="text-[8rem] md:text-[14rem] leading-none font-serif font-black text-black select-none relative z-10 mix-blend-multiply">
            404
            </h1>
        </div>

        {/* Glitch/Tech Banner */}
        <div className="flex justify-center mb-8">
             <div className="bg-black text-white text-lg md:text-2xl font-mono px-6 py-2 uppercase tracking-widest inline-block border-l-4 border-red-600">
                DATA_NOT_FOUND
             </div>
        </div>

        {/* Philosophical Message */}
        <p className="text-lg md:text-xl text-gray-600 font-serif italic mb-12 max-w-lg mx-auto leading-relaxed">
          "Hai raggiunto i confini dell'Atlante. Le coordinate semantiche che cerchi non esistono in questo livello di realtà digitale, o sono state cancellate dal tempo."
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col md:flex-row gap-4 justify-center items-center">
          <Link to="/" className="w-full md:w-auto flex items-center justify-center gap-2 px-8 py-4 bg-black text-white text-xs font-bold uppercase tracking-widest hover:bg-red-600 transition-colors shadow-lg group">
            <Home size={14} className="group-hover:-translate-y-0.5 transition-transform"/> Ritorna alla Base
          </Link>
          
          <div className="text-xs font-bold text-gray-300 uppercase tracking-widest hidden md:block">
            — OPPURE —
          </div>

          <Link to="/atlante" className="w-full md:w-auto flex items-center justify-center gap-2 px-8 py-4 border border-black text-black text-xs font-bold uppercase tracking-widest hover:bg-gray-50 transition-colors group">
            <Terminal size={14} /> Consulta Database
          </Link>
        </div>

        {/* Search Suggestion */}
        <div className="mt-16 pt-8 border-t border-gray-200">
             <p className="text-xs text-gray-400 font-sans uppercase tracking-widest mb-4">
                Cerchi qualcosa di specifico?
             </p>
             <div className="inline-flex items-center border-b border-gray-300 pb-1 gap-2 text-gray-500">
                <Search size={14} />
                <span className="text-sm italic font-serif">Prova a cercare nell'Atlante...</span>
             </div>
        </div>

      </div>
    </div>
  );
};

export default NotFound;
